import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {saveAs} from 'file-saver';
import {InvoiceService} from '../../services/invoice.service';
import {InvoiceDTO} from '../../model/invoiceDTO';
import {CurrencyService} from '../../services/currency-service';
import {NotificationService} from '../../services/notification.service';

@Component({
  templateUrl: './list-invoice.component.html'
})
export class ListInvoiceComponent implements OnInit {

  invoices: InvoiceDTO[];

  constructor(private service: InvoiceService,
              private router: Router,
              private dialog: MatDialog,
              public currency: CurrencyService,
              private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.service.getInvoices().subscribe(invoices => this.invoices = invoices);
  }

  download(invoice: InvoiceDTO) {
    this.service.download(invoice.id).subscribe(pdf => {
      saveAs(pdf, `Reveon factuur - ${invoice.client} ${invoice.payedAt}.pdf`);
      this.notificationService.success('factuur gedownload');
    }, error => this.notificationService.errorResponse(error));
  }

  translateType(type: InvoiceDTO.TypeEnum) {
    switch (type) {
      case 'IDEAL':
        return 'iDEAL';
      case 'SEPA_DIRECT_DEBIT':
        return 'automatische incasso';
      case 'INVOICE':
        return 'factuur';
      case 'GIFT':
        return 'gift';
    }
  }
}
